// extracted by mini-css-extract-plugin
export default {"SelectInput":"checkbox-group_SelectInput__MPG03"};